export const report_relationship_table =  {
  miniTable: true,
  config: [{
    label: '资产负债表“未分配利润”(期末数-年初数)',
    value: 'd1',
    width: 280,
    show: 'normal'
  }, {
    label: '+明细账“以前年度损益调整”(本年累计余额)',
    value: 'd2',
    width: 300,
    show: 'normal'
  }, {
    label: '+资产负债表“盈余公积”(期末数-年初数)',
    value: 'd3',
    width: 280,
    show: 'normal'
  }, {
    label: '= 利润表“净利润”(累计金额)',
    value: 'd4',
    width: 220,
    show: 'normal'
  }],
  operation: {
    label: '操作',
    value: 'operation',
    data: []
  },
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}
export const fixed_assets_table= {
  miniTable: true,
  config: [{
    label: '科目余额表“固定资产”余额',
    value: 'vouchFixed',
    width: 220,
    show: 'normal'
  }, {
    label: '折旧汇总表“原值”',
    value: 'fixedAssets',
    width: 160,
    show: 'normal'
  }],
  operation: {
    label: '操作',
    value: 'operation',
    data: []
  },
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}
export const fixed_depreciation_table= {
  miniTable: true,
  config: [{
    label: '科目余额表“累计折旧”余额',
    value: 'vouchFixed',
    width: 220,
    show: 'normal'
  }, {
    label: '折旧汇总表“期未累计折旧”',
    value: 'fixedAssets',
    width: 180,
    show: 'normal'
  }],
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}
export const advertising_business_promotion_table = {
  miniTable: true,
  config: [{
    label: '年度',
    value: 'year',
    show: 'normal'
  },{
    label: '广告费和业务宣传费',
    width: 200,
    value: 'value',
    show: 'normal'
  },{
    label: '营业收入',
    value: 'operatingRevenue',
    show: 'normal'
  },{
    label: '广告费和业务宣传费占营业收入的比值（%）',
    width: 300,
    value: 'accountFor',
    show: 'normal'
  },{
    label: '纳税调整额',
    width: 220,
    value: 'taxAdjustmentAmount',
    show: 'normal'
  }],
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}
export const business_entertainment_expenses_table = {
  miniTable: true,
  config: [{
    label: '年度',
    value: 'year',
    show: 'normal'
  },{
    label: '业务招待费',
    width: 200,
    value: 'value',
    show: 'normal'
  },{
    label: '营业收入',
    value: 'operatingRevenue',
    show: 'normal'
  },{
    label: '业务招待费占营业收入比值（%）',
    width: 300,
    value: 'accountFor',
    show: 'normal'
  },{
    label: '纳税调整额',
    width: 220,
    value: 'taxAdjustmentAmount',
    show: 'normal'
  }],
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}

export const welfare_expenses_operating_income_table = {
  miniTable: true,
  config: [{
    label: '年度',
    value: 'year',
    show: 'normal'
  },{
    label: '福利费',
    width: 200,
    value: 'value',
    show: 'normal'
  },{
    label: '营业收入',
    value: 'operatingRevenue',
    show: 'normal'
  },{
    label: '福利费占营业收入比值（%）',
    width: 300,
    value: 'accountFor',
    show: 'normal'
  },{
    label: '纳税调整额',
    width: 220,
    value: 'taxAdjustmentAmount',
    show: 'normal'
  }],
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}
export const analysis_service_operating_revenue_table = {
  miniTable: true,
  config: [{
    label: '年度',
    value: 'year',
    show: 'normal'
  },{
    label: '服务费',
    width: 200,
    value: 'value',
    show: 'normal'
  },{
    label: '营业收入',
    value: 'operatingRevenue',
    show: 'normal'
  },{
    label: '服务费占营业收入比值（%）',
    width: 300,
    value: 'accountFor',
    show: 'normal'
  },{
    label: '纳税调整额',
    width: 220,
    value: 'taxAdjustmentAmount',
    show: 'normal'
  }],
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}
export const travel_expenses_table = {
  miniTable: true,
  config: [{
    label: '年度',
    value: 'year',
    show: 'normal'
  },{
    label: '差旅费',
    width: 200,
    value: 'value',
    show: 'normal'
  },{
    label: '营业收入',
    value: 'operatingRevenue',
    show: 'normal'
  },{
    label: '差旅费占营业收入比值（%）',
    width: 300,
    value: 'accountFor',
    show: 'normal'
  },{
    label: '纳税调整额',
    width: 220,
    value: 'taxAdjustmentAmount',
    show: 'normal'
  }],
  data: [],
  center: {
    textAlign: 'center',
    padding: '6px 0',
  }
}



// WEBPACK FOOTER //
// ./src/pages/physical_report/tableInfo.js